import { render, staticRenderFns } from "./homeFriends.vue?vue&type=template&id=b74e84c6&scoped=true"
import script from "./homeFriends.vue?vue&type=script&lang=js"
export * from "./homeFriends.vue?vue&type=script&lang=js"
import style0 from "./homeFriends.vue?vue&type=style&index=0&id=b74e84c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74e84c6",
  null
  
)

export default component.exports